<footer class="{{customClass}}">
  <div class="container top-footer">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <img src="./assets/images/logos/cpa-logo.png" alt="">

        <h6>{{ 'general.footerTitle' | translate }}</h6>

        <ul>
          <li><a href="">{{'general.Site Map' | translate }}</a></li>
          <li><a href="">{{'general.Frequently Asked Questions' | translate }}</a></li>
          <li><a href="">{{'general.privacy policy' | translate }}</a></li>
          <li><a href="">{{'general.Terms of Use' | translate }}</a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="bottom-footer">
    <p>©{{'general.copyright' | translate }}</p>
  </div>
</footer>